import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import ButtonIcon from '../Button/ButtonIcon';

interface ModalCloseButtonProps {
  onClick?: () => void;
  className?: string;
}

const Layout = styled.div`
  position: absolute;
  top: ${toRem(12)};
  right: ${toRem(12)};
  z-index: ${theme.zIndex.modal + 4};
  flex-flow: row nowrap;
  justify-content: flex-end;
  width: 100%;
  height: 0;
  overflow: visible;
`;

const StyledButtonIcon = styled(ButtonIcon)`
  position: relative;
  z-index: ${theme.zIndex.modal + 5};
  border: none;
`;

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({ onClick, className, ...rest }) => (
  <Layout className={className} onClick={onClick}>
    <StyledButtonIcon label="Close Modal" icon="Close" type="button" appearance="secondary" size="small" dataCy="modal-close-btn" {...rest} />
  </Layout>
);

export default ModalCloseButton;
